import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import React from 'react';
import PropTypes from 'prop-types';

import './PlanPublishedTableHeader.theme.scss';

function PlanPublishedTableHeader({ isInHouse }) {
  return (
    <tr className="plan-published-items__header">
      <th>
        <RsTableHeaderLabel />
      </th>
      <th>Optional single step to be added</th>
      <th>Conditions</th>
      <th className="rx-reactions-table__yield">Yield</th>
      <th className="show-for-tablet">{isInHouse ? 'Reference/Experiment' : 'Reference'}</th>
    </tr>
  );
}

PlanPublishedTableHeader.defaultProps = {
  isInHouse: false,
};

PlanPublishedTableHeader.propTypes = {
  isInHouse: PropTypes.bool,
};

export default PlanPublishedTableHeader;
